import styled from '@emotion/styled'

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: auto 1fr; /* Two columns: 1st for title, 2nd for inputs */
  gap: 1.25rem;
  align-items: center;
`

export const InputsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
`

export const RowTitle = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  color: #00000;
  text-align: right;
`

export const StyledInput = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.625rem;
  justify-content: end;
`

export const ParametersInfo = styled.div`
  display: flex;
  justify-content: center;
  gap: 2.875rem;
  padding: 2.875rem;
`

export const ParameterLabel = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 1rem;
  font-weight: 400;
`

export const ParameterValue = styled.span`
  font-weight: bold;
  text-transform: capitalize;
`
